import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.filter.js";
var topicParams = {
  'filter[hot]': 1,
  'filter[content]': '',
  perPage: 5,
  page: 1
};
// const threadListParams = { perPage: 10, page: 1, 'filter[essence]': 0, 'filter[attention]': 0, 'filter[sort]': 3, sequence: 0 }
import $ from 'jquery';
import getPx from '@/utils/getPx';
import { recommendKeywords, topicList } from '@/api/mg';
export default {
  name: 'Search',
  data: function data() {
    return {
      findList: [],
      searchArr: [],
      inputValue: '',
      isEmpty: true,
      transitionName: '',
      arr: ['All', 'Community', 'Activity', 'News'],
      activeName: 'All',
      isResults: false,
      value: '',
      isInput: false,
      historySearchList: JSON.parse(localStorage.getItem('historySearchList')) || [],
      hotSearchList: [],
      hotTopicList: [],
      highLight: false
    };
  },
  watch: {
    '$route': function $route(to, from) {
      var isBack = this.$router.isBack; //  监听路由变化时的状态为前进还是后退
      // console.log(from.meta.index, to.meta.index)
      if (to.meta.index && from.meta.index) {
        if (to.meta.index > from.meta.index) {
          // 设置动画名称
          this.transitionName = 'slide-left';
        } else {
          this.transitionName = 'slide-right';
        }
        return;
      }
      if (isBack) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
      this.$router.isBack = false;
    }
  },
  created: function created() {
    localStorage.removeItem('searchActiveName');
    var params = {
      page: 1,
      perPage: 5
    };
    this.getHotSearchList(params);
    topicParams['filter[recommended]'] = 1;
    this.getTopicList(topicParams);
    // threadListParams.page = 1
    // this.getThreadList(threadListParams)
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      $('#inputs').blur(function () {
        setTimeout(function () {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }, 100);
      });
      var u = navigator.userAgent; // 判断手机类型
      if (u.indexOf('Android') > -1 || u.indexOf('Linux') > -1) {
        console.log('12345');
        if (window.Android) {
          var devicePixelRatio = window.devicePixelRatio;
          console.log(devicePixelRatio);
          console.log(window.Android.getStatusBarHeight());
          var pxSize = Number(window.Android.getStatusBarHeight() / devicePixelRatio);
          console.log('pxsize', pxSize);
          $(".titleBar").css("padding-top", pxSize);
        }
      }
      var el = document.documentElement || document.body;
      var originHeight = el.clientHeight;
      $(window).resize(function () {
        var resizeHeight = el.clientHeight;
        if (resizeHeight < originHeight) {
          console.log('键盘弹起originHeight：' + originHeight);
          console.log('键盘弹起resizeHeight：' + resizeHeight);
        } else {
          console.log('键盘收起originHeight：' + originHeight);
          console.log('键盘收起resizeHeight：' + resizeHeight);
          $('#inputs').blur(); // 触发blur事件
        }
      });
    });
  },
  beforeDestroy: function beforeDestroy() {},
  methods: {
    toAllTopic: function toAllTopic() {
      this.$router.push({
        path: '/social/allTopic'
      });
    },
    toTopic: function toTopic(topicId) {
      this.$router.push({
        path: '/social/topic',
        query: {
          topicId: topicId,
          from: 'search'
        }
      });
    },
    getTopicList: function getTopicList(params) {
      var _this = this;
      topicList(params).then(function (res) {
        if (res.Code === 0) {
          _this.hotTopicList = res.Data.pageData;
        } else {
          _this.$toast(res.Message);
        }
      });
    },
    clearHistory: function clearHistory() {
      localStorage.removeItem('historySearchList');
      this.historySearchList = [];
    },
    getHotSearchList: function getHotSearchList(params) {
      var _this2 = this;
      recommendKeywords(params).then(function (res) {
        if (res.Code === 0) {
          _this2.hotSearchList = res.Data.pageData;
        } else {
          _this2.$toast(res.Message);
        }
      });
    },
    getResult: function getResult(value) {
      var _this3 = this;
      if (value === '') {
        // value = 'ZS EV'
        return;
      }
      if (value.trim()) {
        this.value = value.trim();
        if (localStorage.getItem('historySearchList')) {
          var arr = JSON.parse(localStorage.getItem('historySearchList'));
          console.log(arr, 'arr');
          var flag = arr.every(function (item) {
            return item !== value.trim();
          });
          if (flag) {
            arr.push(value.trim());
          }
          if (arr.length > 5) {
            arr = arr.slice(-5);
          }
          localStorage.setItem('historySearchList', JSON.stringify(arr));
        } else {
          var _arr = [];
          _arr.push(value.trim());
          localStorage.setItem('historySearchList', JSON.stringify(_arr));
        }
        var timer = setTimeout(function () {
          _this3.isResults = true;
          _this3.isInput = false;
          /* 大深坑*/
          // this.$nextTick(() => {
          //   $(this.$refs.tabs.$el).height($(window).height() - $('.input-con').innerHeight() - getPx(102) - $('.van-tabs__wrap').height())
          // })
          _this3.inputValue = value;
          _this3.activeName = localStorage.getItem('searchActiveName') || 'All';
          _this3.tabChange(_this3.activeName);
          // this.$router.replace('/social/search/all')
          clearTimeout(timer);
        }, 100);
      }
    },
    tabChange: function tabChange(name) {
      // 1=Club，2=Acitivity，3=Video，4=News
      localStorage.setItem('searchActiveName', name);
      this.activeName = name;
      var path = name.toLowerCase();
      if (name == 'Community') {
        this.$router.replace({
          path: "/social/search/club"
        });
      } else {
        this.$router.replace({
          path: "/social/search/".concat(path)
        });
      }
      // const index = this.arr.indexOf(name)
      // if (index === 0) {
      //   delete threadListParams['filter[categoryids][0]']
      // } else {
      //   threadListParams['filter[categoryids][0]'] = index
      // }
      // threadListParams['filter[search]'] = this.value
      // this.getThreadList(threadListParams)
      // localStorage.setItem('activeName', name)
    },
    toDetail: function toDetail() {
      this.$router.push({
        path: '/social/detail',
        query: {
          from: 'activity'
        }
      });
    },
    clear: function clear() {
      this.historySearchList = JSON.parse(localStorage.getItem('historySearchList')) || [];
      this.value = '';
      this.isInput = false;
      this.isResults = false;
      this.isEmpty = true;
      this.highLight = false;
    },
    input: function input(value) {
      // if (value) {
      //   if (/[A-Za-z0-9\u0E00-\u0E7F]/.test(value)) {
      //     if (value.trim()) {
      //       if (localStorage.getItem('historySearchList')) {
      //         this.findList = JSON.parse(localStorage.getItem('historySearchList')).filter((item) => {
      //           console.log(item, 'item')
      //           return item.indexOf(value.trim()) !== -1
      //         })
      //         console.log(this.findList, 'this.findList')
      //       }

      //       this.isInput = true
      //       this.isEmpty = false
      //       this.highLight = true
      //     } else {
      //       this.isResults = false
      //       this.isInput = false
      //       this.isEmpty = true
      //       this.highLight = false
      //     }
      //   } else {
      //     this.highLight = false
      //     this.$refs.inputs.blur()
      //     this.value = ''

      //     if (localStorage.getItem('language') === '"th"') {
      //       console.log(localStorage.getItem('language'))
      //       this.$toast({
      //         message: 'ไม่สามารถป้อนอักษรพิเศษได',
      //         position: 'center'
      //       })
      //     } else {
      //       this.$toast({
      //         message: 'special characters are not allowed',
      //         position: 'center'
      //       })
      //     }
      //   }
      // }
      if (value) {
        if (value.trim()) {
          if (localStorage.getItem('historySearchList')) {
            this.findList = JSON.parse(localStorage.getItem('historySearchList')).filter(function (item) {
              console.log(item, 'item');
              return item.indexOf(value.trim()) !== -1;
            });
            console.log(this.findList, 'this.findList');
          }
          this.isInput = true;
          this.isEmpty = false;
          this.highLight = true;
        } else {
          this.isResults = false;
          this.isInput = false;
          this.isEmpty = true;
          this.highLight = false;
        }
      }
    }
  }
};